import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { useQuery } from '@tanstack/react-query';

/**
 * Se a proposta RD já foi transmitida (`GET /:proposalId/transmission`). O
 * Motor não tem esse estado — `aceita` é só a proposta gerada —, então quem
 * responde é o BFF, pelo controle de emissão. Só consulta a partir de
 * `aceita`: antes disso não há o que transmitir.
 */
export function useRdTransmission(
  proposalId: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['rd-transmission', proposalId],
    queryFn: async () => {
      if (!proposalId) {
        throw new Error('ProposalId é obrigatório');
      }

      const response = await rdEquipamentosService.getTransmission(proposalId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao consultar a transmissão da proposta'
        );
      }

      return response.data;
    },
    enabled: !!proposalId && enabled,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}
